import { observer, inject } from "mobx-react";
import Composite from "app/components/BookElements/Composite";
const Component = inject("AppState")(observer(Composite));
Component.displayName = "SECTION III";
export const BookSectionTwoComponent = Composite;
export default Component;



// WEBPACK FOOTER //
// ./src/app/components/BookElements/SectionIii.js